/* mv swiper */
let fv_swiper = new Swiper(".fv-swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
	},
	effect: "fade",
	speed: 1200,
	fadeEffect: {
		crossFade: true,
	},
	pagination: {
		el: ".swiper-pagination",
		type: "bullets",
		clickable: true,
	},
});
fv_swiper.autoplay.stop();
/* headline swiper */
let headline_swiper = new Swiper(".headline-swiper", {
	loop: true,
	autoplay: false,
	navigation: {
		nextEl: ".headline-swiper-next",
		prevEl: ".headline-swiper-prev",
	},
});
/* cookie */
if (Cookies.get("towel_splash")) {
	document.querySelector(".l-splash").remove();
	document.querySelector(".home-fv__side").classList.remove("invisible");
	document.querySelector(".home-fv__main").classList.remove("invisible");
	fv_swiper.autoplay.start();
}
if (!Cookies.get("towel_splash")) {
	Cookies.set("towel_splash", "mita!");
	document.querySelector(".l-splash").classList.add("finished");
	document.querySelector(".l-splash img").classList.add("fadein");
	document.querySelector(".home-fv__main").classList.remove("fadein");
	document.querySelector(".home-fv__side").classList.add("fadein");
	document.querySelector(".home-fv__main").classList.add("fadein");
	window.setTimeout(fv_swiper.autoplay.start, 6000);
}

/* SP 100vh */
if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
	function setHeight() {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);
	}
	setHeight();
}

/* home-product */
let items = document.querySelectorAll(".js-product-info");
if (items) {
	let item_height = 0;
	for (let i = 0; i < items.length; i++) {
		if (item_height < items[i].offsetHeight) {
			item_height = items[i].offsetHeight;
		}
	}
	let meta = document.getElementById("js-product-meta");
	meta.style.height = item_height + "px";
}

/* product swiper */
$(document).ready(function () {
	$(".js-product-info").eq(0).addClass("active");
});

let product_swiper = new Swiper(".product-swiper", {
	loop: true,
	autoplay: false,
	navigation: {
		nextEl: ".product-swiper-next",
		prevEl: ".product-swiper-prev",
	},
});
product_swiper.on("slideChange", function () {
	const current_no = product_swiper.activeIndex - 1;
	const items_sum = items.length;

	for (let i = 0; i < items.length; i++) {
		items[i].classList.remove("active");
	}

	if (current_no < items_sum && current_no >= 0) {
		items[current_no].classList.add("active");
	}

	if (current_no >= items_sum) {
		items[0].classList.add("active");
	}

	if (current_no < 0) {
		items[items_sum - 1].classList.add("active");
	}
});

/* Header scroll event */
window.addEventListener("scroll", () => {
	let jsHeader = document.querySelector(".l-header");
	let currentY = window.pageYOffset;
	if (currentY > 300) {
		jsHeader.classList.add("active");
	} else {
		jsHeader.classList.remove("active");
	}
});
